import { MessageCircle } from "lucide-react";
import { CONTACT } from "../lib/data";
import { trackContact } from "../lib/fb";

const links = [
  { label: "Manifesto", href: "#manifesto" },
  { label: "Services", href: "#services" },
  { label: "Work", href: "#gallery" },
  { label: "Contact", href: "#contact" },
];

export const Nav = () => (
  <nav
    data-testid="main-nav"
    className="fixed top-0 left-0 right-0 z-50 bg-[#F4F4F0]/85 backdrop-blur-md border-b border-black"
  >
    <div className="flex items-center justify-between px-4 sm:px-6 md:px-12 h-16">
      <a href="#top" data-testid="nav-logo" className="font-display font-bold text-base sm:text-lg tracking-tight uppercase">
        Siddharth Offsets<span className="text-[#FF3B30]">®</span>
      </a>
      <div className="hidden md:flex items-center gap-8">
        {links.map((l) => (
          <a
            key={l.href}
            href={l.href}
            data-testid={`nav-link-${l.label.toLowerCase()}`}
            className="font-mono text-xs uppercase tracking-[0.2em] hover:text-[#FF3B30] transition-colors duration-200"
          >
            {l.label}
          </a>
        ))}
      </div>
      <a
        href={CONTACT.whatsappHref}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="nav-whatsapp-link"
        onClick={trackContact}
        className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-widest border border-black bg-[#25D366] px-3 sm:px-4 py-2 hover:bg-black hover:text-[#25D366] transition-colors duration-200"
      >
        <MessageCircle size={14} />
        <span className="hidden sm:inline">WhatsApp us</span>
        <span className="sm:hidden">Chat</span>
      </a>
    </div>
    <div className="flex h-1.5" aria-hidden="true">
      <span className="flex-1 bg-[#00AEEF]" />
      <span className="flex-1 bg-[#EC008C]" />
      <span className="flex-1 bg-[#FFD200]" />
      <span className="flex-1 bg-[#0E0E0E]" />
    </div>
  </nav>
);
